<template>
  <div>
    <h2 class="mc-h2">Documents and photos</h2>
    <p class="mc-lede">
      Attach clear photos of your documents and vehicle. Items marked required
      must be attached — everything else helps but isn't mandatory.
    </p>

    <p class="mc-hint mc-docs-hint">
      <span v-if="missingCount" class="is-err">
        {{ missingCount }} required item{{ missingCount > 1 ? 's' : '' }} still
        needed
      </span>
      <template v-else>All required items attached ✓</template>
    </p>
    <photo-doc-capture
      :items="docs"
      :captured="captured"
      @select="(key, file) => $emit('capture', key, file)"
      @remove="(key) => $emit('remove-capture', key)"
      @error="(key, msg) => $emit('capture-error', key, msg)"
    />
  </div>
</template>

<script>
import PhotoDocCapture from './PhotoDocCapture.vue'

// Shared photo/document capture screen — every journey (online-form today,
// paper-upload/AI later) needs the same capture grid, just with a different
// docs list.
export default {
  name: 'DocumentsStep',
  components: { PhotoDocCapture },
  props: {
    // [{ key, label, hint?, required?, accept? }]
    docs: { type: Array, required: true },
    captured: { type: Object, default: () => ({}) },
  },
  computed: {
    missingCount() {
      return this.docs.filter((d) => d.required && !this.captured[d.key]).length
    },
  },
}
</script>

<style scoped>
.mc-h2 {
  font-size: 19px;
  font-weight: 700;
  margin: 0 0 6px;
  color: #14142b;
}

.mc-lede {
  font-size: 14.5px;
  color: #6e7191;
  margin: 0 0 20px;
}

.mc-hint {
  font-size: 12.5px;
  color: #6e7191;
  margin: 6px 0 0;
}

.mc-docs-hint {
  margin: -4px 0 12px;
}

.mc-hint .is-err {
  color: #eb5757;
  font-weight: 500;
}
</style>
